// removed by extract-text-webpack-plugin
module.exports = {"text800":"_1gkD0fycXUHtxhrpHD6iuN","text700":"_2zjOovWtq9KdN8Y2dFLqJf","text600":"_1uXR9uKpJs21kWpzN_zdFE","text500":"_14ueY1eoKKuHwYQ-MZyfp0","text400":"c2xl8IBu2dCvfeLZhSNmP","text300":"_2ziQfpKnh56bDMTqd46N8a","text200":"_1GFKz4w4iVhzMvGWcE8954","textParagraph":"itDZKPa5onq_twa8F7CoU","crimp":"StQenFNxSqE_U_9f95MUa","trim":"_3ekJte0H0USi1Jrb98AfUv","flexCenter":"pIUYMC2hSvKxMSG8QI5m0","hideTextOverflow":"_27BL6eOu7caDnBP8FqX_1F","marginPageMainContent":"uGeaNAMsU9vtptvOoPdq-","flag":"_29P74MOZUMWOj15YhKTWkF"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/utilities/IconFlag.scss
// module id = 1015
// module chunks = 0